import { jsx as _jsx, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import PlaceListNameChip from '@/components/PlaceListNameChip';
import useNavigation from '@/navigation/useNavigation';
export default function PlaceTags({ chips }) {
    const navigation = useNavigation();
    if (chips.length === 0) {
        return null;
    }
    // 스크롤은 부모(접근레벨 배지까지 포함한 한 줄)가 담당 — 여기선 배지들만 나열.
    return (_jsx(_Fragment, { children: chips.map((chip, index) => {
            const placeListId = chip.placeListId;
            return (_jsx(View, { style: { marginRight: 4 }, children: _jsx(PlaceListNameChip, Object.assign({}, chip, { elementName: "place_tag_place_list", logParams: { placeListId }, trackView: true, onPress: () => {
                        if (placeListId) {
                            navigation.navigate('PlaceListDetail', {
                                placeListId,
                                initialViewMode: 'list',
                            });
                        }
                    } })) }, placeListId !== null && placeListId !== void 0 ? placeListId : index));
        }) }));
}
